import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const SeiLogoSquare = t0 => {
  const $ = _c(12);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs><linearGradient id="sei-logo-square-gradient" x1="49.916%" x2="49.916%" y1="99.578%" y2="0%"><stop offset="0%" stopColor="#B52A2A" /><stop offset="100%" stopColor="#780000" /></linearGradient></defs>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <g fill="none" fillRule="evenodd"><path d="M24 24V0H0v24z" fill="url(#sei-logo-square-gradient)" /><path d="M11.979 20.4a8.415 8.415 0 0 0 6.283-2.804 2.002 2.002 0 0 0-2.564-.045l-.146.117a3.38 3.38 0 0 1-4.635-.378 1.804 1.804 0 0 0-2.515-.167l-1.683 1.439a8.404 8.404 0 0 0 5.26 1.838Zm2.732-4.07a3.579 3.579 0 0 1 4.487.002 8.35 8.35 0 0 0 1.207-4.337c0-1.763-.544-3.4-1.474-4.75-.6-.128-1.25.02-1.743.457l-.14.124A3.38 3.38 0 0 1 12.4 7.66a1.804 1.804 0 0 0-2.52-.051L7.92 9.448 6.844 8.305l1.96-1.838a3.38 3.38 0 0 1 4.72.097 1.804 1.804 0 0 0 2.482.088l.14-.124c.436-.386.94-.646 1.469-.782a8.407 8.407 0 0 0-5.635-2.156c-4.278 0-7.811 3.18-8.354 7.298a3.458 3.458 0 0 1 3.96.7 1.882 1.882 0 0 0 2.5.167l1.096-.854a3.652 3.652 0 0 1 4.639.124l2.132 1.853-1.033 1.183-2.132-1.853a2.077 2.077 0 0 0-2.638-.07l-1.095.853a3.457 3.457 0 0 1-4.593-.308 1.882 1.882 0 0 0-2.629-.057l-.237.222a8.359 8.359 0 0 0 1.988 4.62l1.795-1.536a3.38 3.38 0 0 1 4.712.314c.64.714 1.728.803 2.475.202l.146-.118Z" fill="#FFF" /></g>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== className || $[9] !== rest || $[10] !== t2) {
    t5 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}{t4}</svg>;
    $[8] = className;
    $[9] = rest;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export const SeiLogoSquareMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M0 0h24v24H0V0Zm11.979 20.4a8.415 8.415 0 0 0 6.283-2.804 2.002 2.002 0 0 0-2.564-.045l-.146.117a3.38 3.38 0 0 1-4.635-.378 1.804 1.804 0 0 0-2.515-.167l-1.683 1.439a8.404 8.404 0 0 0 5.26 1.838Zm2.732-4.07a3.579 3.579 0 0 1 4.487.002 8.35 8.35 0 0 0 1.207-4.337c0-1.763-.544-3.4-1.474-4.75-.6-.128-1.25.02-1.743.457l-.14.124A3.38 3.38 0 0 1 12.4 7.66a1.804 1.804 0 0 0-2.52-.051L7.92 9.448 6.844 8.305l1.96-1.838a3.38 3.38 0 0 1 4.72.097 1.804 1.804 0 0 0 2.482.088l.14-.124c.436-.386.94-.646 1.469-.782a8.407 8.407 0 0 0-5.635-2.156c-4.278 0-7.811 3.18-8.354 7.298a3.458 3.458 0 0 1 3.96.7 1.882 1.882 0 0 0 2.5.167l1.096-.854a3.652 3.652 0 0 1 4.639.124l2.132 1.853-1.033 1.183-2.132-1.853a2.077 2.077 0 0 0-2.638-.07l-1.095.853a3.457 3.457 0 0 1-4.593-.308 1.882 1.882 0 0 0-2.629-.057l-.237.222a8.359 8.359 0 0 0 1.988 4.62l1.795-1.536a3.38 3.38 0 0 1 4.712.314c.64.714 1.728.803 2.475.202l.146-.118Z" fill={fillAttribute} fillRule="nonzero" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};